// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clock[data-v-172e2136]{margin-top:4px}.work-hours[data-v-172e2136]{font-family:Courier New,Courier,monospace}", ""]);
// Exports
module.exports = exports;
